import mixpanel from "mixpanel-browser";
import Cookies from "js-cookie";
import { MIXPANEL_TOKEN } from "../constants/constants";
const IGNORED_PATHS = [
  "form-approval",
  "blog-genie",
  "form-templates"
]



export default class MixPanel {
  constructor() {

    mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN, {
      debug: false,
      track_pageview: "full-url",
      persistence: "localStorage",
    });
  }
  identify(id) {
    mixpanel.identify(id);
  }
  alias(id) {
    mixpanel.alias(id);
  }
  trackPageView() {
    const pageTitle = document.title;
    const url = window.location.href
    let isIgnored = IGNORED_PATHS.some(str1 => {
      // console.log(str1, url, url.includes(str1))
      return url.includes(str1)
    })
    // console.log("isIgnored", isIgnored)
    if (isIgnored) {
      console.log('==== URL IS IGNORED ====', url)
      return;
    }
    const dashboard_language = Cookies.get("googtrans");
    mixpanel.track("Page View - " + pageTitle, { dashboard_language });
  }
  track(name, props) {
    mixpanel.track(name, props);
  }
  peopleSet(props) {
    mixpanel.people.union(props);
  }
  increment(props) {
    mixpanel.people.increment(props);
  }
  trackAndIncrement(name, trackProp, incProp) {
    mixpanel.track(name, trackProp);
    mixpanel.people.increment(incProp);
  }
  setupMixPanel() {
    mixpanel.identify();
    // trackPageView();
  }
}
